import { Helmet } from 'react-helmet';
import { isProduction } from '../../utils/isProduction';

export default function Chat() {
   const useSandbox = !isProduction();

   return (
      <Helmet>
         <script
            type='text/javascript'
            id='hs-script-loader'
            async
            defer
            src={
               useSandbox
                  ? '//js-eu1.hs-scripts.com/143825039.js'
                  : '//js-eu1.hs-scripts.com/143450730.js'
            }
         ></script>
      </Helmet>
   );
}
